module.exports = __webpack_public_path__ + "static/media/menu-1.18c1aa2a.jpg";